import { render } from "./IconKeywordSearch.vue?vue&type=template&id=75d13816"
import script from "./IconKeywordSearch.vue?vue&type=script&lang=js"
export * from "./IconKeywordSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__